import React, { Component } from 'react';
import PropTypes from 'prop-types';
import iconLocation from '../../images/icons/icon_32_location.png';
import { withTranslation } from 'react-i18next';

class MeetingPoint extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { meetingPoint, t } = this.props;
    return (
      <section className="fe-trip-map">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h4 className="fe-trip-main-heading">{t('form:meetingPoint')}</h4>
              <div className="fe-trip-map-container">
                <div className="fe-trip-map-google">
                  <div className="fe-trip-map-aspectratio">
                    <iframe src={meetingPoint.google_map_url} frameBorder="0" allowFullScreen></iframe>
                  </div>
                </div>
                <div className="fe-trip-map-details">
                  <h5 className="fe-trip-map-place">
                    <img src={iconLocation} alt=""/>
                    {meetingPoint.place_name}
                  </h5>
                  <p
                    className="fe-trip-map-address"
                    dangerouslySetInnerHTML={{__html: meetingPoint.address}}
                  />
                  <p className="fe-trip-map-contact">
                    {meetingPoint.phone_no}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

MeetingPoint.propTypes = {
  meetingPoint: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MeetingPoint);